var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-port-body",class:_vm.$route.meta.outerClass,attrs:{"id":"app"}},[(_vm.showHeader)?_c('header-part',{staticClass:"header-vue"}):_vm._e(),_c('all-svg'),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.appState.showVuePopup),expression:"!appState.showVuePopup"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }